<template>
  <footer class="footer">
    <div class="container-fluid">
      <!-- <div class="copyright">&copy; {{ year }}, Smartbooks</div> -->
    </div>
  </footer>
</template>
<script>
export default {
};
</script>
<style></style>
